import axios from 'axios';
import config from '../config'
import Bugsnag from "@bugsnag/js";
import firebase from "firebase";

export const changeCurrentTrackWithDelay = async () => {
    try {
        await axios.get(config.functionsApi + '/changeCurrentTrack');
    } catch (e) {
        Bugsnag.notify(e);
        console.log({...e})
    }
}

export const shuffleTracksWithDelay = async () => {
    try {
        await axios.get(config.functionsApi + '/shuffleTracks');
    } catch (e) {
        Bugsnag.notify(e);

        console.log({...e})
    }
}

export const updatePlayedTracks = async () => {
    try {
        await axios.get(config.functionsApi + '/updatePlayedTracks');
    } catch (e) {
        Bugsnag.notify(e);

        console.log({...e})
    }
};

export const updateShowTally = async () => {
    try {
        await axios.get(config.functionsApi + '/updateShowTally');
    } catch (e) {
        Bugsnag.notify(e);

        console.log({...e})
    }
}
export const getToken = async () => {
    let idToken = ''
    try {
        idToken = await firebase.auth().currentUser.getIdToken(true)
    } catch (error) {
        console.log(error.toString()) // eslint-disable-line no-console
    }
    return idToken
}

export const getTracks = async (genres, page) =>{
    try{
        const jwt = await getToken()
        const response = await axios({
            method: 'GET',
            url:`${config.apiUrl}/discovery`,
            params:{genres, page, limit:50},
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        return response
    }catch (e) {
        console.log(e)
    }
}

export const getGenres = async () =>{
    try{
        const jwt = await getToken()
        const response = await axios({
            method: 'GET',
            url:`${config.apiUrl}/genre`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        return response
    }catch (e) {
        console.log(e)
    }
}

